import { styled } from 'stitches.config'

export const PostBannerRoot = styled('div', {
  borderRadius: '22px',
  padding: '$4 $3',

  '@bp2': {
    padding: '$5 $6',
  },

  '@bp3': {
    padding: '$7 $8',
  },
})

export const ImageContainer = styled('div', {
  position: 'relative',
  maxWidth: '280px',

  '@bp1': {
    maxWidth: '400px',
  },

  '@bp2': {
    maxWidth: '50%',
  },

  '.isologo': {
    position: 'absolute',
    left: 0,
    top: 0,
  },

  img: {
    maxWidth: '100%',
  },
})

export const ContentWrapper = styled('div', {
  margin: 'auto',

  '@bp3': {
    maxWidth: '60%',
    margin: 'inherit',
  },
})
